export default __webpack_public_path__ + "static/media/attachment.3c3d52c8.svg";